<script setup lang="ts">
const props = defineProps<{
  boxData: any;
  videoImage?: any;
}>();

const boxData = props.boxData;

const getYoutubeThumbnailUrl = (url: string | undefined) => {
  if (!url) return null;
  const regex =
    /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
  const match = url.match(regex);
  const videoId = match ? match[1] : null;
   return match ? `https://img.youtube.com/vi/${videoId}/0.jpg` : null;
};
</script>
<template>
  <div class="cust-slide-inspire px-4">
    <div class="container mx-auto pt-12 pb-16 sm:py-24 relative">
      <div class="slider inspire-you-slider">
        <div class="inner-wrap">
          <div class="grid grid-cols-1 md:grid-cols-2 gap-0">
            <div class="flex flex-col justify-center left w-full md:w-[350px] lg:w-[488px] mb-6 md:mb-0">
              <div class="description">
                <h5
                  v-if="boxData?.custom_recepiefields_titlevideo"
                  class="font-bold leading-normal text-lg md:text-2xl mb-4"
                >
                  {{ boxData?.custom_recepiefields_titlevideo }}
                </h5>
                <div
                  v-if="boxData?.custom_recepiefields_textvideo"
                  class="text-sm font-normal text-dark-bg leading-relaxed mb-8"
                  v-html="boxData?.custom_recepiefields_textvideo"
                ></div>
                <NuxtLink
                  v-if="
                    boxData?.custom_recepiefields_youtubelink &&
                    boxData?.custom_recepiefields_buttontext
                  "
                  :to="boxData?.custom_recepiefields_youtubelink"
                  target="_blank"
                  class="btn-default btn-black-bg btn-default px-11"
                >
                  {{ boxData?.custom_recepiefields_buttontext }}
                </NuxtLink>
              </div>
            </div>

            <div class="right py-0 lg:pl-8 xl:pl-2">
              <div class="wrap-img">
                <figure
                  v-if="
                    videoImage?.url ||
                    getYoutubeThumbnailUrl(
                      boxData?.custom_recepiefields_youtubelink
                    )
                  "
                  class="relative hover:cursor-pointer group"
                >
                  <NuxtImg
                    v-if="videoImage?.url"
                    ref="imageElement"
                    loading="lazy"
                    format="webp"
                    :height="videoImage?.metaData?.height"
                    :width="videoImage?.metaData?.width"
                    :src="videoImage?.url"
                    :alt="boxData?.custom_recepiefields_titlevideo || ''"
                    class="w-full h-auto rounded-lg group-hover:opacity-90"
                    data-testid="inspire-img"
                  />

                  <NuxtImg
                    v-else-if="boxData?.custom_recepiefields_youtubelink"
                    ref="imageElement"
                    loading="lazy"
                    format="webp"
                    :src="
                      getYoutubeThumbnailUrl(
                        boxData?.custom_recepiefields_youtubelink
                      )
                    "
                    :alt="boxData?.custom_recepiefields_titlevideo || ''"
                    class="w-full h-auto rounded-lg group-hover:opacity-90"
                    data-testid="inspire-img"
                  />

                  <SharedFancybox :options="{}">
                    <a
                      data-fancybox=""
                      :href="boxData?.custom_recepiefields_youtubelink"
                      class="w-full h-full flex justify-center items-center absolute top-0 left-0 z-10 group"
                      :class="{
                        'pointer-events-none':
                          !boxData?.custom_recepiefields_youtubelink,
                      }"
                    >
                      <div
                        v-if="boxData?.custom_recepiefields_youtubelink"
                        class="absolute top-1/2 left-1/2 bg-red-bg h-12 w-12 transition-all duration-300 group-hover:scale-120 text-white flex items-center justify-center rounded-full"
                      >
                        <i class="fa fa-play"></i>
                      </div>
                      <span v-else class="absolute text-2xl ml-2">
                        <i
                          class="fa-solid fa-spinner animate-spin text-white"
                        ></i>
                      </span>
                    </a>
                  </SharedFancybox>
                </figure>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
